<div class="container-fluid" style="max-height: 75vh; overflow-y: auto;">

  <div class="row">

    <div class="col-sm-6 mb-4">
      <app-treeview-systems
            parent_icon="folder"
            child_icon="videocam"
            parent_table_name="ngaccessmanagement_ngfoldertree"
            parent_table_pk="id"
            parent_table_ref_value="item_name"
            child_table_name="ngaccessmanagement_ngsystemprofile"
            child_table_displayname="system_name"
            child_table_fk="folder_id_id"
            algorithm="m2mtable"
            title="Location"
            sort_by = "folder"
            [has_checkbox] = "false"
            (messageSelectedFolder)="recieve_selected_folder($event)"
          ></app-treeview-systems>
    </div>

    <div class="col-sm-6 text-center mb-4" >
      <div style="max-height: 75vh;">
        <h3 style="background-color: black; color: white; padding: 10px;">Please enter systems IP-Password comma separated</h3>
        <form (ngSubmit)="onSubmitTextArea()" #f="ngForm" >
          <div class="col-sm-12" style="margin: solid black;">
            <mat-form-field class="system-units" appearance="fill" style="width: 100%;">
              <mat-label>IP-Password, ....</mat-label>
              <textarea matInput placeholder="ex: IP1-pass1, IP2-pass2,...etc"
               name="systems" id="systems" [(ngModel)]="insertedSystemsText"
               #systems="ngModel" autocomplete="off" required
               cdkTextareaAutosize cdkAutosizeMinRows="10" cdkAutosizeMaxRows="100">
              </textarea>
            </mat-form-field>
            <div class="text-danger" *ngIf="!systems.valid || systems.untouched">
              <span *ngIf="systems.errors">
                Enter an IP-Password format
              </span>
            </div>
          </div>

          <div class="col-sm-12">
            <button mat-raised-button  color="primary" style="margin-right: 5px;"
            type="submit" [disabled]="!f.valid">Confirm</button>
            <button mat-raised-button color="accent" style="margin-left: 5px;"
             (click)="clearTextArea()" >Clear</button>
          </div>

        </form>
      </div>


    </div>

    <div class="col-sm-12 text-center mb-4" >

            <mat-form-field appearance="fill" style="width: 20%; margin: 0px 2px 0px 2px;">
              <mat-label>Units Market</mat-label>
              <mat-select  [(value)]="selectedMarketName" (selectionChange)="fetchMarketLocations()">
                <mat-option *ngFor="let market of availableMarkets" [value]="market.text">{{market.text}}</mat-option>
              </mat-select >
            </mat-form-field>

            <mat-form-field appearance="fill" style="width: 20%;margin: 0px 2px 0px 2px;">
              <mat-label>Locations Available</mat-label>
              <mat-select  [(value)]="selectedMarketLocationId">
                <mat-option *ngFor="let location of availableMarketLocations" [value]="location">{{location.text}}</mat-option>
              </mat-select >
            </mat-form-field>

            <mat-form-field appearance="fill" style="width: 20%;margin: 0px 2px 0px 2px;">
              <mat-label>Provision units</mat-label>
              <mat-select  [(value)]="provisionUnitsChoice">
                <mat-option [value]="0">No</mat-option>
                <mat-option [value]="1">Yes</mat-option>
              </mat-select >
            </mat-form-field>

            <mat-form-field appearance="fill" style="width: 20%;margin: 0px 2px 0px 2px;">
              <mat-label>Monitor units</mat-label>
              <mat-select  [(value)]="monitorUnitsChoice" >
                <mat-option [value]="0">No</mat-option>
                <mat-option  *ngIf="changemonitoringselection()" [value]="1" >Yes</mat-option>
              </mat-select >
            </mat-form-field>
    </div>

    <div class="col-sm-12 text-center">
      <h3 style="background-color: black; color: white; padding: 10px;">Units to be added</h3>

      <h3 *ngIf="getInsertedSystemsKeys().length==0" style="color:red">
        * Insert in the textbox above the units to be added !
      </h3>

        <form (ngSubmit)="onSubmitData()" #ff="ngForm">

          <div style="max-height:75vh;overflow-y:auto;">
            <table *ngIf="getInsertedSystemsKeys().length>0"
              mat-table [dataSource]="getInsertedSystemsKeys()"
              class="mat-elevation-z8 col-sm-12">

              <ng-container matColumnDef="deleteIcon">
                <td mat-cell *matCellDef="let element;" style="width: 1vw;">
                  <div style="display: inline-block;">
                    <mat-icon aria-hidden="false" aria-label="delete_forever" matTooltip="Remove"
                  class="deleteSingleRow" (click)="removeSingleRow(element)">delete_forever</mat-icon>
                  </div>
              </td>
              </ng-container>

              <ng-container matColumnDef="ip">
                <td mat-cell *matCellDef="let element;"  style="width:13vw">

                  <mat-form-field  appearance="fill" style="width:12.5vw">
                    <mat-label>IP</mat-label>
                    <input matInput [(ngModel)]="insertedSystems[element][0]"  autocomplete="off"
                    [name]="element+'IP'" required maxlength="15" minlength="7" #ipAddr="ngModel"
                    pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$">

                    <mat-error *ngIf="ipAddr.errors">
                      Invalid IPV4 format
                    </mat-error>

                  </mat-form-field>

              </td>
              </ng-container>

              <ng-container matColumnDef="password">
                <td  mat-cell *matCellDef="let element" style="width:13vw">
                  <mat-form-field  appearance="fill" style="width:12.5vw">
                    <mat-label>Password</mat-label>
                    <input matInput [(ngModel)]="insertedSystems[element][1]" #sysPass="ngModel"  autocomplete="off"
                    [name]="element+'Password'">
                    <span *ngIf="insertedSystems[element][1].length==0" style="font-size: 75%;color: green;">
                      * Note system password is empty
                     </span>
                    <!-- pattern="^(?=.*[A-Z])(?=.*[!@#$%^&*_=+-]).{6,100}$" -->
                    <!-- <mat-error *ngIf="sysPass.hasError('pattern') && !sysPass.hasError('minlength')">
                      upper case, special char. req.
                    </mat-error> -->
                  </mat-form-field>
                </td>
              </ng-container>

              <ng-container matColumnDef="targetFolder">
                <td  mat-cell *matCellDef="let element"
                [ngStyle]="{'color': (!targetFolder.text) ? 'red' : 'black'}" style="width:13vw">
                    <mat-form-field  appearance="fill" style="width:12.5vw">
                      <mat-label>Designated folder</mat-label>
                      <input matInput [(ngModel)]="targetFolder.text"
                        [disabled]="true"  [name]="element+'Folder'" required>
                        <span *ngIf="!targetFolder.text" style="font-size: 75%;color:red;">
                        * select folder from tree {{folderAddError}}
                        </span>

                    </mat-form-field>
                </td>
              </ng-container>

              <ng-container matColumnDef="market">
                <td  mat-cell *matCellDef="let element"
                [ngStyle]="{'color': (!selectedMarketName) ? 'red' : 'black'}" style="width:13vw">
                    <mat-form-field  appearance="fill" style="width:12.5vw">
                      <mat-label>Selected market</mat-label>
                      <input matInput [(ngModel)]="selectedMarketName"
                        [disabled]="true"  [name]="element+'Market'" required>
                        <span *ngIf="!selectedMarketName" style="font-size: 75%;color:red;">
                        * select a market from above
                        </span>
                    </mat-form-field>
                </td>
              </ng-container>

              <ng-container matColumnDef="location">
                <td  mat-cell *matCellDef="let element"
                [ngStyle]="{'color': (!selectedMarketLocationId) ? 'red' : 'black'}" style="width:13vw">
                    <mat-form-field  appearance="fill" style="width:12.5vw">
                      <mat-label>Selected location</mat-label>
                      <input matInput [(ngModel)]="selectedMarketLocationId.text"
                        [disabled]="true"  [name]="element+'Location'" required>
                        <span *ngIf="!selectedMarketLocationId.id" style="font-size: 75%;color:red;">
                        * select a location from above
                        </span>
                    </mat-form-field>
                </td>
              </ng-container>

              <ng-container matColumnDef="provision">
                <td  mat-cell *matCellDef="let element"
                [ngStyle]="{'color': (!provisionUnitsChoice) ? 'red' : 'black'}" style="width:7.5vw">
                    <mat-form-field  appearance="fill" style="width:6.25vw">
                      <mat-label>Provision unit</mat-label>
                      <input matInput [value]=" provisionUnitsChoice==0?'No':'Yes' "
                        [disabled]="true"  [name]="element+'Provision'" required>
                        <span *ngIf="provisionUnitsChoice==null" style="font-size: 75%;color:red;">
                        * select a provision state from above
                        </span>
                    </mat-form-field>
                </td>
              </ng-container>

              <ng-container matColumnDef="monitor">
                <td  mat-cell *matCellDef="let element"
                [ngStyle]="{'color': (!monitorUnitsChoice) ? 'red' : 'black'}" style="width:7.5vw">
                    <mat-form-field  appearance="fill" style="width:6.25vw">
                      <mat-label>Monitor unit</mat-label>
                      <input matInput [value]=" monitorUnitsChoice==0?'No':'Yes' "
                        [disabled]="true"  [name]="element+'Monitor'" required>
                        <span *ngIf="monitorUnitsChoice==null" style="font-size: 75%;color:red;">
                        * select a monitor state from above
                        </span>
                    </mat-form-field>
                </td>
              </ng-container>


              <ng-container matColumnDef="state">
                <td mat-cell *matCellDef="let element;">
                  <mat-spinner strokeWidth="3" [diameter]="20" *ngIf="processingFlag"></mat-spinner>
                  <mat-icon aria-hidden="false" aria-label="check_circle"
                  matTooltip="Success" style="color: green;"
                  *ngIf="!processingFlag && resultReceivedFlag && insertedSystems[element][2]==null">
                  check_circle</mat-icon>
                  <mat-icon aria-hidden="false" aria-label="error"
                  [matTooltip]="insertedSystems[element][2]" style="color: red;"
                  *ngIf="!processingFlag && resultReceivedFlag && insertedSystems[element][2]!=null">
                  error</mat-icon>

                  <span style="width:12.5vw" *ngIf="!processingFlag && resultReceivedFlag && insertedSystems[element][2]!=null"
                        style="font-size: 75%;color:red;">
                          {{insertedSystems[element][2]}}
                    </span>
              </td>

              </ng-container>

            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [attr.id]="row+'ID'" class="form-group"></tr>
            </table>
          </div>

          <div class="col-sm-12" *ngIf="getInsertedSystemsKeys().length>0">
            <button mat-raised-button  color="primary"
            style="margin-left: auto;margin-right: auto; margin-top: 10px !important;"
            type="submit" [disabled]="!ff.valid || !targetFolder.text || disableAfterFetchingData||!selectedMarketLocationId.id">Add Systems</button>

          </div>

        </form>

    </div>

    <div id="closeBtn">
      <mat-icon aria-hidden="false" class="fa-2x"  style="width: 100%; color: grey;" id="closeBtn" (click)="onNoClick()">close</mat-icon>
    </div>

  </div>

</div>


